// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  chassisKey: __t.string().name("chassis_key"),
  reason: __t.string(),
  fromX: __t.f32().name("from_x"),
  fromZ: __t.f32().name("from_z"),
  destX: __t.f32().name("dest_x"),
  destZ: __t.f32().name("dest_z"),
  curX: __t.f32().name("cur_x"),
  curZ: __t.f32().name("cur_z"),
  cruiseAlt: __t.f32().name("cruise_alt"),
  altitude: __t.f32(),
  speed: __t.f32(),
  yaw: __t.f32(),
  arriveState: __t.string().name("arrive_state"),
  startedAt: __t.timestamp().name("started_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
